/* 01 Demo
    ================================================== */



/* 03 Revolution Slider
    ================================================== */
jQuery( function( $) {
  $( document ).delegate( '[data-section-type="ss"]', 'ss-init', function() {
    $( this ).each( function() {
      var e = $( this );
      
      e.revolution({
        delay: e.attr( 'data-delay' ),
        startwidth: e.attr( 'data-w' ),
        startheight: e.attr( 'data-h' ),
        hideThumbs: 10
      });
    });
  } );
  
} );

/* 04 Counter
    ================================================== */
jQuery( function( $) {
  $( document ).delegate( '.milestone-counter', 'milestone-init', function() {
    $( this ).each( function() {
      var e = $(this);
        e.find('.milestone-count').delay(6000).countTo({
          from: 0,
          to: e.attr('data-perc'),
          speed: 2500,
          refreshInterval: 80
        });
      
    } );
  
  } ).delegate( '.milestone-counter', 'inview', function() {
  	$( this ).trigger( 'milestone-init' );
  });
  
} );

/* 05 Articles: slider
    ================================================== */
jQuery( function( $) {
  $( document ).delegate( '.owl-carousel', 'owl-init', function() {
    $( this ).each( function() {
      var e = $( this );
      
      e.owlCarousel({
        navigation: eval( e.attr( 'data-nav' ) || 0 ) == 1,
        navigationText: ['<i class="icon-left-open"></i>', '<i class="icon-right-open"></i>'],
        pagination: eval( e.attr( 'data-dots' ) || 0 ) == 1,
        rewindNav: true,
        autoPlay: false,
        items: eval( e.attr( 'data-items' ) || 1 ),
        mouseDrag: true,
        autoHeight: true,
        itemsDesktop: [1200, 3],
        itemsDesktopSmall: [1024, 3],
        itemsTablet: [970, 2],
        itemsMobile: [767, 1]
      });
    });
  } );
  
} );

/* 00 Shopify section
    ================================================== */
jQuery( function( $ ) {
  var doc = $( document ),
      o = {
        '[data-section-type="ss"]': 'ss-init',
        '.milestone-counter': 'milestone-init',
        '.owl-carousel': 'owl-init'
      }
 ;
  doc.delegate( '.shopify-section', 'render-css', function() {
    $( this ).find( '.shopify-section-css' ).each( function() {
      var e = $( this ),
          id = e.attr( 'data-id' )
      ;
      $( '#' + id ).remove();
      $( 'head' ).append( '<style id="' + id + '">' + e.html() + '</style>' );
    } );
  } );
  
  $.each( o, function( k, v ) {
  	doc.on( 'shopify:section:load', function( e ) {
      $( e.target ).trigger( 'render-css' )
      .find( k ).trigger( v );
    } ).on( 'shopify:section:select', function( e ) {
      $( e.target ).trigger( 'render-css' )
      .find( k ).trigger( v );
    } ).on( 'shopify:block:select', function( e ) {
      $( e.target ).closest( '.shopify-section' ).trigger( 'render-css' )
      .closest( k ).trigger( v );
    } );

    $( k ).trigger( v );
  } );
  
  $( '.shopify-section' ).trigger( 'render-css' );
} );

jQuery(function($){
  $(document).delegate('[data-gtoggle]', 'click', function(){
    $($(this).attr('data-target')).toggleClass('in');
  });
});

